export default "__VITE_ASSET__c86db7f3__"